export const iconFontAwesomeHumanitarianRoadLock = (
	<i className="fa-solid fa-road-lock"></i>
);
